import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom'
import { AuthGuard } from './router/guards'
import { AdminGuard } from './router/guards'
import { PublicLayout } from './layouts/PublicLayout'
import { AppShellLayout } from './layouts/AppShellLayout'
import Landing from './pages/Landing'
import Login from './pages/Login'
import ForgotPassword from './pages/ForgotPassword'
import ResetPassword from './pages/ResetPassword'
import Dashboard from './pages/Dashboard'
import ProjectNew from './pages/ProjectNew'
import ProjectDetail from './pages/ProjectDetail'
import Settings from './pages/Settings'
import Symon from './pages/Symon'
import AdminProjects from './pages/AdminProjects'
import AdminProjectDetail from './pages/AdminProjectDetail'
import ConfirmEmail from './pages/ConfirmEmail'

const router = createBrowserRouter([
  {
    element: <PublicLayout />,
    children: [
      { path: '/', element: <Landing /> },
      { path: '/login', element: <Login /> },
      { path: '/forgot-password', element: <ForgotPassword /> },
      { path: '/reset-password', element: <ResetPassword /> },
      { path: '/projects/new', element: <ProjectNew /> },
      { path: '/confirm-email', element: <ConfirmEmail /> },
    ],
  },
  {
    element: <AuthGuard />,
    children: [
      {
        element: <AppShellLayout navMode="client" />,
        children: [
          { path: '/dashboard', element: <Dashboard /> },
          { path: '/projects/:id', element: <ProjectDetail /> },
          { path: '/settings', element: <Settings /> },
          { path: '/symon', element: <Symon /> },
        ],
      },
    ],
  },
  {
    element: <AdminGuard />,
    children: [
      {
        element: <AppShellLayout navMode="admin" />,
        children: [
          { path: '/admin/projects', element: <AdminProjects /> },
          { path: '/admin/projects/:id', element: <AdminProjectDetail /> },
        ],
      },
    ],
  },
  { path: '*', element: <Navigate to="/" replace /> },
])

export default function App() {
  return <RouterProvider router={router} />
}
